/**
 * Labstep
 */

import { PostFilter } from 'labstep-web/services/postFilter';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';

export const PostFilterEntityState = new PostFilter(
  [['name', PostFilterComparison.eq]],
  'entityState',
);

export const getPostFilterEntityState = (path?: string) =>
  new PostFilter(
    [['name', PostFilterComparison.eq]],
    path ? path : 'entityState',
  );
